import IVenue from "../interfaces/IVenue";
import { SET_VENUE_DATA } from "../const";
import IVenueSettings from "../interfaces/IVenueSettings";
import ILocationAPIObject from "../interfaces/ILocationAPI";
import { SET_USERS_VENUES, UPDATE_VENUE_FEES, RESET_USERS_VENUES } from "../yoello-lib/modules/redux/actions/venue.actions";
import { IFee } from "../yoello-lib/modules/interfaces/IFee";

export interface IVenueReducerState {
    [key: string]: IVenueObject;
}

export interface IVenueObject {
    [key: string]: any;
    venueData?: IVenue;
    venueSettings?: IVenueSettings;
    venueLocation?: ILocationAPIObject;
    venueFees?: IFee[];
}
const initalState: IVenueReducerState = {

};


const venueReducer = (state = initalState, action: any) => {
    // console.log('venueReducer', action, state);
    switch (action.type) {
        case SET_VENUE_DATA:
            const { venueDataKey, venueData, venueId } = action.payload;
            if (venueId in state === false) {
                state[venueId] = {};
            }
            state[venueId] = {
                ...state[venueId],
                [venueDataKey]: venueData
            };
            return {
                ...state
            };
        case SET_USERS_VENUES:
            const venueArray = action.payload;
            const reduced = reduceVenues(venueArray, state);
            return {
                ...state,
                ...reduced
            };
        case RESET_USERS_VENUES:
            state = {};
            return state
        case UPDATE_VENUE_FEES:
            const { feeObject, venueId: vId } = action.payload;
            const venue = state[vId];
            let venueFees = venue?.venueFees;
            if (venueFees) {
                const index = findFee(feeObject, venueFees);
                /**If we have the object in mem already we replace with new object */
                if (index > -1) {
                    venueFees.splice(index, 1, feeObject);
                } else {
                    venueFees.push(feeObject);
                }
            } else {
                /**If no venue fees then we create a new array */
                venueFees = [feeObject];
            }
            state[vId] = {
                ...state[vId],
                venueFees
            };
            return {
                ...state,
            };
        default:
            return state;
    }
};

function findFee(feeObject: IFee, feeArray: IFee[]) {
    return feeArray.findIndex((fee) => fee.fee_type === feeObject.fee_type);
}

function reduceVenues(venuesArray: IVenue[], state: IVenueReducerState): {
    [key: string]: IVenueObject;
} {
    return venuesArray.reduce((pItem: any, venue: IVenue) => {
        const oldData = state[venue.id!] ?? {};
        return {
            ...pItem,
            [venue.id!]: { ...oldData, venueData: venue }
        };
    }, {});
}

export default venueReducer;